import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

/** Создаём Router с автогенерированным routeTree.
 *  - defaultPreload='intent' — TanStack Router начинает префетч на hover/focus.
 *  - basepath='/admin' — admin SPA замаунчен под `/admin/` на всех хостах
 *    (admin.ds2b.ru/admin/..., <slug>.ds2b.ru/admin/...). См. vite.config.ts
 *    `base: '/admin/'` — это две стороны одной разводки. */
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  basepath: '/admin',
})

// Type-safe router context — стандартный паттерн TanStack Router.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export function App() {
  return <RouterProvider router={router} />
}
